import type { AiAppCenterModule } from '../types'

/**
 * 律所 ERP（Track F：客户 / Matter / 工时 / 卷宗…）
 * 后端 system_module.name=lawyer-firm；独立窗 /ai-Application-center/lawyer-firm/*
 * 与「律师平台」lawyer 并列；机构日常主入口另见 /firm（ADR-026）
 */
export const lawyerFirmModule: AiAppCenterModule = {
  key: 'lawyer-firm',
  label: '律所 ERP',
  desc: '所内客户 CRM、案件工作台、工时收费、卷宗开庭、行政财务',
  path: '/lawyer-firm',
  homePath: '/lawyer-firm/dashboard',
  menuPaths: ['/lawyer-firm'],
  icon: 'ep:briefcase',
  color: '#1677ff',
  aliases: ['律所ERP', '律所办案', 'Firm ERP', 'Track F']
}
